import { ICON_TYPES } from "@shared/common/constants";
import { typography } from "@shared/common/Themes/typography";
import {
  HelperTooltip,
  HelperTooltipProps,
} from "common/Tooltips/HelperTooltip";
import TextWithIcon from "common/Text/TextWithIcon";
import Title from "common/Typography/Title";
import useMedia from "utils/hooks/useMedia";
import { useTheme } from "styled-components";
import { useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { DISPLAY_CURRENCIES } from "common/constants";

interface StatisticItemProps {
  title: string;
  value: number | string | React.JSX.Element;
  helperProps?: HelperTooltipProps;
}

const MobileStatisticItem = ({
  title,
  value,
  helperProps,
}: StatisticItemProps) => {
  const theme = useTheme();
  const isSmallMobile = useMedia([`(max-width: 400px)`], [true], false);
  const displayCurrency = useSelector(selectDisplayCurrency);
  const isBtc = displayCurrency === DISPLAY_CURRENCIES.BTC;

  return (
    <div>
      <TextWithIcon
        text={value}
        iconType={ICON_TYPES.DISPLAY_CURRENCY}
        style={{
          fontSize: typography.fontSizes[isSmallMobile ? "M" : "L"],
        }}
        textStyle={{ color: theme.colors.primaryText }}
        iconStyle={{
          color: theme.colors.primaryText,
          fontSize: typography.fontSizes.S,
          marginRight: 2,
          marginBottom: isBtc ? 2 : 0,
          opacity: 0.5,
        }}
      />
      <Title
        $weight={typography.fontWeights.SEMI_BOLD}
        $size={isSmallMobile ? typography.fontSizes.XS : typography.fontSizes.S}
        type="secondary"
      >
        {title}
        {helperProps && (
          <HelperTooltip {...helperProps} containerStyle={{ marginLeft: 4 }} />
        )}
      </Title>
    </div>
  );
};

export default MobileStatisticItem;
